module.exports = __webpack_public_path__ + "assets/img/logo_top.be0692fb.png";